<script lang="ts" setup>
useSquircleObserver()

const client = useSupabaseClient()
const loading = ref(false)
import { Button } from '@/components/ui/button'
import { Loader2 } from 'lucide-vue-next'

const { disabled, redirectTo } = defineProps<{
  disabled?: boolean
  redirectTo?: string
}>()

const signInWithOAuth = async (provider: 'google' | 'azure') => {
  // Save the redirect_to URL to localStorage
  if (redirectTo) {
    // Always preserve the state parameter for both MCP and non-MCP redirects
    const urlParams = new URLSearchParams(window.location.search)
    const state = urlParams.get('state')
    
    let completeRedirectUrl = redirectTo
    if (state && !redirectTo.includes('state=')) {
      // Check if the URL already has query parameters
      if (redirectTo.includes('?')) {
        completeRedirectUrl = `${redirectTo}&state=${state}`
      } else {
        completeRedirectUrl = `${redirectTo}?state=${state}`
      }
    }
    
    console.log('[DEBUG] Saving complete redirect_to to localStorage:', completeRedirectUrl)
    localStorage.setItem('mcp_redirect_to', completeRedirectUrl)
  }
  
  // Use the standard Supabase callback URL
  // The confirm.vue page will check localStorage for the saved redirect_to
  let redirectUrl = `${window.location.origin}/confirm`
  
  let options = {
    redirectTo: redirectUrl,
    scopes: provider === 'azure' ? 'email' : undefined
  }
  
  console.log('[DEBUG] Social OAuth redirect URL:', redirectUrl)
  
  const { error } = await client.auth.signInWithOAuth({
    provider,
    options
  })
  if (error) console.log(error)
}



</script>

<template>
  <div class="grid grid-cols-1 gap-4 py-3">
    <Button @click.stop.prevent="async () => signInWithOAuth('google')" :disabled="disabled" variant="secondary"
      class="squircle-10">
      <Loader2 v-if="loading" class="w-4 h-4 mr-2 animate-spin" />
      <Icon v-else class="w-4 h-4 mr-3" name="logos:google-icon" />
      <span class="whitespace-nowrap text-[1.1em]">
        Continue with Google
      </span>
    </Button>

    <Button @click.stop.prevent="async () => signInWithOAuth('azure')" :disabled="disabled" variant="secondary"
      class="squircle-10">
      <Loader2 v-if="loading" class="w-4 h-4 mr-2 animate-spin" />
      <Icon v-else class="w-4 h-4 mr-3" name="logos:microsoft-icon" />
      <span class="whitespace-nowrap text-[1.1em]">
        Sign in with Microsoft
      </span>
    </Button>
  </div>
</template>

<style scoped></style>
